import {
  blue500,
  grey50,
  grey500,
  red50,
  red500,
  red700,
} from 'material-ui/styles/colors';

import { CSSProperties } from 'react';
import { TooltipStyles } from 'react-lightweight-tooltip';

export const highPriorityBackgroundColor = red700;
export const highPriorityLabelColor = red50;
export const skipSummaryBackgroundColor = red700;

export const skipSummaryLabelColor = red50;

export const styles = {
  servingCappingWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginRight: '25px',
  } as CSSProperties,
  chipStyle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  } as CSSProperties,
  titleText: {
    fontWeight: 800,
    color: '#01BCD4',
  } as CSSProperties,
  countryContainer: {
    padding: '15px',
    marginBottom: '15px',
  } as CSSProperties,
  selectedCountry: {
    display: 'inline-block',
    background: blue500,
    color: 'white',
    borderRadius: '15px',
    padding: '5px 10px',
    cursor: 'pointer',
    marginRight: '3px',
    fontSize: '11px',
  } as CSSProperties,
  unSelectedCountry: {
    display: 'inline-block',
    background: grey50,
    color: 'black',
    borderRadius: '15px',
    padding: '5px 10px',
    cursor: 'pointer',
    marginRight: '3px',
    fontSize: '11px',
  } as CSSProperties,
  readableChip: {
    margin: 1,
    display: 'inline-block',
    borderRadius: '1em',
    fontSize: '0.9em',
  } as CSSProperties,
  clickableChip: {
    margin: 1,
    display: 'inline-block',
  } as CSSProperties,
  highPriority: {
    //margin: 1,
    background: highPriorityBackgroundColor,
    color: highPriorityLabelColor,
    display: 'inline-block',
    borderRadius: '1em',
    fontSize: '0.9em',
  } as CSSProperties,
  highPriorityButton: {
    background: highPriorityBackgroundColor,
    color: highPriorityLabelColor,
  } as CSSProperties,
  spanLabel: {
    color: grey500,
  } as CSSProperties,
  minWidthNone: {
    minWidth: 'none',
  } as CSSProperties,
  width10: {
    width: '10%',
    maxWidth: 'none',
  } as CSSProperties,
  width17: {
    width: '17%',
    maxWidth: 'none',
  } as CSSProperties,
  width20: {
    width: '20%',
    maxWidth: 'none',
  } as CSSProperties,
  width25: {
    width: '25%',
    maxWidth: 'none',
  } as CSSProperties,
  width33: {
    width: '33%',
    maxWidth: 'none',
  } as CSSProperties,
  width40: {
    width: '40%',
    maxWidth: 'none',
  } as CSSProperties,
  width45: {
    width: '45%',
    maxWidth: 'none',
  } as CSSProperties,
  width50: {
    width: '50%',
    maxWidth: 'none',
  } as CSSProperties,
  width65: {
    width: '65%',
    maxWidth: 'none',
  } as CSSProperties,
  width75: {
    width: '75%',
    maxWidth: 'none',
  } as CSSProperties,
  width80: {
    width: '80%',
    maxWidth: 'none',
  } as CSSProperties,
  width83: {
    width: '83%',
    maxWidth: 'none',
  } as CSSProperties,
  width100: {
    width: '100%',
    maxWidth: 'none',
  } as CSSProperties,
  width110: {
    width: '110%',
    maxWidth: 'none',
  } as CSSProperties,
  inputStyle: {
    color: '#505050',
    fontSize: '0.9em',
  } as CSSProperties,
  textareaStyle: {
    color: '#505050',
    fontSize: '0.9em',
  } as CSSProperties,
  spacedRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  } as CSSProperties,
  detailsFull: {
    // flexDirection: 'column',
    display: 'inline-block',
    width: '90%',
  } as CSSProperties,
  leftDiv: {
    display: 'block',
    width: '70%',
  } as CSSProperties,
  detailsLeft: {
    flexDirection: 'column',
    width: '40%',
    padding: '5px',
  } as CSSProperties,
  detailsMiddle: {
    flexDirection: 'column',
    width: '50%',
    padding: '5px',
  } as CSSProperties,
  detailsLeftAndMiddle: {
    flexDirection: 'column',
    width: '80%',
    padding: '5px',
  } as CSSProperties,
  detailsRight: {
    flexDirection: 'column',
    width: '10%',
    padding: '5px',
  } as CSSProperties,
  rightTopCornerDiv: {
    position: 'absolute',
    right: 0,
    top: 0,
    color: grey500,
    padding: '5px',
  } as CSSProperties,
  rightBottomCornerDiv: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    color: grey500,
    padding: '5px',
  } as CSSProperties,
  form: {
    display: 'flex',
    flexWrap: 'wrap',
  } as CSSProperties,
  flag: {
    margin: 2,
    display: 'inline-block',
    width: '25%',
    minWidth: 'none',
  } as CSSProperties,
  flagButton: {
    marginLeft: '2px',
    cursor: 'pointer',
    float: 'right',
  } as CSSProperties,
  actionButton: {
    margin: '2px auto',
    display: 'block',
    height: 'inherit',
    padding: '6px',
  } as CSSProperties,
  marginTopLeft: {
    margin: '-8px 0 0 -23px',
  } as CSSProperties,
  marginBottomOnly: {
    marginBottom: '10px',
  } as CSSProperties,
  marginTopOnly: {
    marginTop: '10px',
  } as CSSProperties,
  hearts: {
    // backgroundImage: "url('" + '../../../assets/images/' + 'heart_gray.png' + "')",
    // backgroundRepeat: 'no-repeat',
    // backgroundPosition: 'right center'
  } as CSSProperties,
  tableHeader: {
    // fontSize: '16px',
    // color: 'rgba(0, 0, 0, 0.3)',
    // textAlign: 'left',
    // wordWrap: 'break-word',
    // paddingLeft: '0px'
  } as CSSProperties,
  tooltipStyle: {
    wrapper: {
      zIndex: 1,
      cursor: 'arrow',
    },
    tooltip: {
      backgroundColor: '#808080',
      borderRadius: '10px',
      minWidth: '180px',
      textAlign: 'center',
      padding: '2px',
    },
    content: {
      backgroundColor: '#808080',
      color: '#FFFFFF',
      display: 'inline-block',
      fontSize: '0.9em',
      paddind: '0',
    },
    arrow: {
      borderTop: 'solid #808080 5px',
    },
    gap: {},
  } as TooltipStyles,
  dropdownHeader: {
    color: '#b2b2b2',
  } as CSSProperties,
  disclaimer: {
    display: 'inline-block',
    margin: '0 20px',
    color: 'red',
  } as CSSProperties,
  alertMessage: {
    color: '#E0B32D',
    display: 'flex',
    alignItems: 'flex-start',
  } as CSSProperties,
  emojiImg: {
    height: '32px',
    width: '32px',
  } as CSSProperties,
  emojiEditWrapper: {
    backgroundColor: 'rgba(0, 0, 0, 0.38)',
    borderRadius: '100px',
    height: '48px',
    width: '48px',
    display: 'flex',
    alignItems: 'center',
  } as CSSProperties,
  emojiHoverWrapper: {
    position: 'absolute',
    visibility: 'hidden',
  } as CSSProperties,
  popoverStyle: {
    height: '436px',
    width: '312px',
    borderRadius: '10px',
    backgroundColor: 'white',
  } as CSSProperties,
  popoverhr: {
    width: '100%',
    marginTop: '12px',
    marginBottom: '14px',
  } as CSSProperties,
  popoverUpper: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '14px',
    justifyContent: 'center',
  } as CSSProperties,
  fileuploadImg: {
    position: 'absolute',
    right: '18px',
    top:'13px'
  } as CSSProperties,
  popoverEmojimr: {
    marginBottom: '3px',
    marginRight: '3px',
  } as CSSProperties,
  popoverCenter: {
    width: '280px',
    display: 'flex',
    flexDirection: 'column',
    height: '340px',
    overflowY:'scroll'
  } as CSSProperties,
  contextualEmoji: {
    height: '100%',
    width: '48px',
    marginRight: '7px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as CSSProperties,
  popoverEmojiContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  } as CSSProperties,
  popoverButtonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '280px',
    height: '52px',
  } as CSSProperties,
  popoverCancelBtn: {
    border: '1.2px solid #C2C2C2',
    borderRadius: '4px',
    width: '136px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as CSSProperties,
  popoverReplaceBtn: {
    background: '#2A97FF',
    borderRadius: '4px',
    width: '136px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    border: 'none',
  } as CSSProperties,
  emojiErrorCont: {
    minWidth: '320px',
    height: '68px',
    border: '1px solid rgba(235, 87, 87, 1)',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
  } as CSSProperties,
  errorBold: {
    fontFamily: 'Roboto',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '20px',
  } as CSSProperties,
  errorMessage: {
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: 'rgba(0, 0, 0, 0.38)',
  } as CSSProperties,
  errorCont: {
    paddingLeft: '14.67px',
  } as CSSProperties,
  errorBorder: {
    borderRadius: '100px',
    border: '1px solid rgba(235, 87, 87, 1)',
  } as CSSProperties,
  emojiUploadErrorMessageContainer: {
    // paddingTop: '5px',
    paddingBottom: '5px',
  } as CSSProperties,
  emojiUploadErrorMessage: {
    fontSize: '14px',
    color: '#eb5757',
    textAlign: 'left',
  } as CSSProperties,
  emojiPopoverContainer: {
      display:'flex',
      flexFlow: 'wrap',
  } as CSSProperties,
  emojiStyling: {
    position: 'relative',
    marginRight: '3px',
    marginBottom: '3px',
  } as CSSProperties,
  emojiInnerMargin: {
    marginRight: '3px',
    marginBottom: '3px',
  } as CSSProperties,
  chosenEmoji: {
    position: 'absolute',
    bottom: 0,
    right: '3px',
  } as CSSProperties,
  emojiHeading: {
    fontSize: '14px',
    lineHeight: '16px',
    fontWeight: 'normal',
    color: '#616161',
  } as CSSProperties,
  euGroup: {
    fontSize: '16px',
    lineHeight: '16px',
    fontWeight: 'normal',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  } as CSSProperties,
  euCountry: {
    fontSize: '16px',
    lineHeight: '16px',
    fontWeight: 'bold',
    minWidth: '20%',
    margin: 0,
  } as CSSProperties,
};



// WEBPACK FOOTER //
// ./src/pages/drafts/styles/draftDetailsStyle.ts